import _ from 'underscore'
import Vue from 'vue'
import live from '@/live'
import api from '@/api'

export default {

	namespaced: true,

	state: {
		data: {
			groups: []
		}
	},

	getters: {

		all: function(state) {

			return _.sortBy(state.data.groups, function(item) {

				return item.title.toLowerCase()

			})

		},

		find: function(state) {

			return function(id) {

				return _.findWhere(state.data.groups, {
					id: parseInt(id)
				})

			}

		},

		'find/category': function(state) {

			return function(id) {

				return _.where(state.data.groups, {
					category: parseInt(id)
				})

			}

		}

	},

	mutations: {

		set: function(state, data) {

			state.data.groups = data.groups

		},

		update: function(state, data) {

			var index = _.findIndex(state.data.groups, {
				id: parseInt(data.id)
			})

			if (index !== -1) {
				
				Vue.set(state.data.groups, index, data)

			} else {

				state.data.groups.push(data)

			}

		},

		order: function(state, data) {

			var index = _.findIndex(state.data.groups, {
				id: parseInt(data.id)
			})

			Vue.set(state.data.groups[index], 'order', data.order)

		},

		delete: function(state, data) {

			var index = _.findIndex(state.data.groups, {
				id: parseInt(data.id)
			})

			state.data.groups.splice(index, 1)

		}

	},

	actions: {

		init: function(context, data) {

			context.commit('set', data)

			live.$on('group/add', function(params) {

				context.commit('update', params)

			})

			live.$on('group/update', function(params) {

				context.commit('update', params)

			})

			live.$on('group/delete', function(params) {

				context.commit('delete', params)

			})

		},

		save: function(context, data) {

			return (data.id) ? api.put('group/' + data.id, data) : api.post('group', data)

		},

		delete: function(context, data) {

			return api.delete('group/' + data.id, data)

		},

		reorder: async function(context, data) {

			_.each(data, function(id, index) {

				context.commit('order', {
					id: id,
					order: index + 1
				})

			})

			await api.post('groups/order', {
				order: data
			})

		}

	}

}
